<template>
  <el-container>
    <Navbar />
    <!--    <el-header height="106px">-->
    <!--      <el-row-->
    <!--        align="middle"-->
    <!--        class="container"-->
    <!--        justify="space-between"-->
    <!--        style="height: 100%"-->
    <!--        type="flex"-->
    <!--      >-->
    <!--        <img-->
    <!--          alt="Aqua Expeditions logo"-->
    <!--          class="logo"-->
    <!--          src="../assets/images/logo@2x.png"-->
    <!--        />-->
    <!--        <a v-if="accessToken" class="btn-logout" @click="onClickLogout"-->
    <!--          >Logout</a-->
    <!--        >-->
    <!--        <div class="brand-name">Online check-in</div>-->
    <!--      </el-row>-->
    <!--    </el-header>-->
    <el-main>
      <nav-steps></nav-steps>

      <!-- route outlet -->
      <!-- component matched by the route will render here -->
      <router-view></router-view>
      <dialog-save-and-exit></dialog-save-and-exit>
      <div
        v-loading.fullscreen.lock="this.isLoading"
        :element-loading-text="this.loadingText"
      ></div>
      <Footer v-if="!$route.meta.hideFooter" show-links />
    </el-main>
    <!--<el-footer class="layout-footer-center">Copyright &copy; 2018 Aqua Expeditions</el-footer>-->
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import types from "../store/types";
import logoutMixin from "../mixins/logout";
import Navbar from "./layouts/Navbar.vue";
import Footer from "./ui/Footer.vue";

export default {
  mixins: [logoutMixin],
  components: { Footer, Navbar },
  computed: {
    ...mapGetters([
      types.getters.isLoading,
      types.getters.loadingText,
      types.getters.accessToken,
    ]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

.btn-logout {
  margin-left: auto;
  margin-right: 36px;
  color: #c9c9c9;

  &:hover {
    cursor: pointer;
  }
}

.logo {
  height: 23px;
}

.brand-name {
  @include typo-bold(24);
  color: $brand-color;
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue